import styled from 'styled-components';

interface ShippingCountryWrapperProps {
  onClick: () => void;
}

const ShippingCountryWrapper = styled.div<ShippingCountryWrapperProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export default ShippingCountryWrapper;
